import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiProductService } from './shared/api-services/product.service';

@Injectable({
  providedIn: 'root',
})
export class CategoriesResolver implements Resolve<any> {

  /**
   * Constructor
   *
   * @param {ApiProductService} apiProductService
   */
  public constructor(private apiProductService: ApiProductService) { }

  /**
   * Resolver for the game periods
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   *
   * @return {Observable<any>}
   */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if(
      this.apiProductService.categories.value != undefined && 
      this.apiProductService.categories.value.length > 0
    ) {
      return [];
    }
    return this.apiProductService.getCategories().pipe(
        map((categoriesData) => {
            return categoriesData;
          }),
    );
  }
}
